import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", {
  align: "center",
  class: "mt-4"
}, "Broadcasting", -1)
const _hoisted_2 = { align: "center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1)

import { useI18n } from 'vue-i18n'
import { ref, onMounted, computed, Ref } from 'vue'
import { Delta } from '@vueup/vue-quill'
import { broadcastingActions } from '@/stores/broadcasting-store'
import { RequestResponse } from '@/types'
import { useToast } from 'vue-toast-notification'

import MessageComponent from './MessageComponent/MessageComponent.vue'
import MessageBox from '@/components/Static/MessageBox/MessageBox.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BroadcastingMessages',
  setup(__props) {

const { t } = useI18n()
const content = ref<Delta | undefined>()
const title = ref<string>('')
const broadcast = ref(false)
const requestResponse = ref<RequestResponse>()
const rerenderKey = ref(0)

const closeDialog = async (response: RequestResponse) => {
  requestResponse.value = response
  broadcast.value = false
  rerenderKey.value++
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_request_status, {
      response: requestResponse.value,
      isLoading: false
    }, null, 8, ["response"]),
    (_openBlock(), _createElementBlock("div", { key: rerenderKey.value }, [
      _hoisted_1,
      _createVNode(_component_v_divider, { class: "mt-3" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          class: "mt-10",
          color: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (broadcast.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "mr-3" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-radio-tower")
              ]),
              _: 1
            }),
            _createTextVNode(" Broadcast")
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _createVNode(MessageComponent),
      _createVNode(MessageBox, {
        content: content.value,
        title: title.value,
        broadcast: broadcast.value,
        editView: false,
        modelValue: broadcast.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((broadcast).value = $event)),
        studentView: false,
        onClosed: _cache[2] || (_cache[2] = ($event: any) => (closeDialog($event))),
        onCloseDialog: _cache[3] || (_cache[3] = ($event: any) => (broadcast.value = false))
      }, null, 8, ["content", "title", "broadcast", "modelValue"])
    ]))
  ], 64))
}
}

})